(function () {
  var canonicalPath = '/products/vida-zephyr-v2-tower-black';
  var temporaryPath = '/products/vida-zephyr-v2-tower-black-build';

  if (window.location.pathname === temporaryPath) {
    window.location.replace(canonicalPath + window.location.search + window.location.hash);
    return;
  }

  var css = [
    'html body .elite-product-main{z-index:auto!important}',
    'html body .elite-product-main .elite-product-main__media-column{display:block!important;align-self:start!important;position:relative!important;height:auto!important;min-height:0!important;overflow:visible!important}',
    'html body .elite-product-main .elite-product-main__media-column>.elite-product-gallery{display:grid!important;grid-template-rows:auto auto auto!important;gap:14px!important;position:relative!important;inset:auto!important;align-self:start!important;order:initial!important;z-index:auto!important;width:100%!important;height:auto!important;min-height:0!important;overflow:visible!important;contain:none!important}',
    'html body .elite-product-main .elite-product-gallery>.elite-product-gallery__main{display:grid!important;place-items:stretch!important;position:relative!important;width:100%!important;max-width:100%!important;aspect-ratio:4/3!important;min-height:clamp(340px,38vw,520px)!important;height:auto!important;max-height:none!important;padding:0!important;overflow:hidden!important}',
    'html body .elite-product-main .elite-product-gallery>.elite-product-gallery__main>.elite-product-gallery__main-button{display:grid!important;place-items:center!important;position:relative!important;width:100%!important;height:100%!important;min-height:100%!important;max-width:100%!important;padding:0!important;box-sizing:border-box!important;overflow:hidden!important}',
    'html body .elite-product-main .elite-product-gallery__main-image{display:block!important;position:absolute!important;left:32px!important;top:32px!important;right:auto!important;bottom:auto!important;width:calc(100% - 64px)!important;height:calc(100% - 64px)!important;max-width:none!important;max-height:none!important;object-fit:contain!important;object-position:center center!important}',
    'html body .elite-product-main .elite-product-gallery>.elite-product-gallery__thumbs{display:grid!important;grid-template-columns:repeat(6,minmax(0,1fr))!important;gap:10px!important;position:relative!important;inset:auto!important;align-self:auto!important;order:initial!important;width:100%!important;height:auto!important;min-height:0!important;padding:0!important;margin-top:0!important;overflow:visible!important}',
    'html body .elite-product-main .elite-product-gallery>.elite-product-gallery__thumbs>.elite-product-gallery__thumb{display:grid!important;place-items:center!important;width:100%!important;height:auto!important;min-height:0!important;aspect-ratio:1/1!important;padding:6px!important;box-sizing:border-box!important;overflow:hidden!important}',
    'html body .elite-product-main .elite-product-gallery>.elite-product-gallery__thumbs>.elite-product-gallery__thumb img{display:block!important;width:100%!important;height:100%!important;max-width:100%!important;max-height:100%!important;object-fit:contain!important;object-position:center center!important}',
    'html body .elite-product-gallery-modal{z-index:4010!important}',
    'html body.elite-gallery-modal-open .elite-product-main,html body.elite-gallery-modal-open .elite-product-gallery{z-index:4000!important}',
    'html body.elite-gallery-modal-open .elite-header__mega{pointer-events:none!important}',
    '@media(min-width:1121px){html body .elite-product-main .elite-product-main__grid{align-items:stretch!important}html body .elite-product-main .elite-product-main__media-column,html body .elite-product-main .elite-product-details{align-self:stretch!important;height:auto!important;min-height:100%!important}html body .elite-product-main .elite-product-main__media-column{align-content:stretch!important;align-items:stretch!important;display:grid!important;grid-template-rows:minmax(0,1fr)!important}html body .elite-product-main .elite-product-main__media-column>.elite-product-gallery,html body .elite-product-main .elite-product-details__core{height:100%!important;min-height:100%!important}html body .elite-product-main .elite-product-main__media-column>.elite-product-gallery{align-self:stretch!important;grid-template-rows:minmax(0,1fr) auto auto!important;gap:14px!important}html body .elite-product-main .elite-product-gallery>.elite-product-gallery__main,html body .elite-product-main .elite-product-gallery>.elite-product-gallery__main>.elite-product-gallery__main-button{height:100%!important}}',
    '@media(max-width:640px){html body .elite-product-main .elite-product-main__media-column>.elite-product-gallery{gap:10px!important}html body .elite-product-main .elite-product-gallery>.elite-product-gallery__main{min-height:260px!important;max-height:340px!important}html body .elite-product-main .elite-product-gallery>.elite-product-gallery__main>.elite-product-gallery__main-button{padding:0!important;touch-action:pan-y!important}html body .elite-product-main .elite-product-gallery__main-image{left:18px!important;top:18px!important;width:calc(100% - 36px)!important;height:calc(100% - 36px)!important}html body .elite-product-main .elite-product-gallery>.elite-product-gallery__thumbs{box-sizing:border-box!important;display:flex!important;gap:8px!important;overflow-x:auto!important;overflow-y:visible!important;width:calc(100% + 8px)!important;padding:16px 16px 9px 8px!important;margin-left:-8px!important;margin-top:-16px!important;scroll-padding-inline:8px 16px!important}html body .elite-product-main .elite-product-gallery>.elite-product-gallery__thumbs>.elite-product-gallery__thumb{flex:0 0 72px!important;width:72px!important}}'
  ].join('');

  function injectCss() {
    if (document.getElementById('elite-gallery-cache-hotfix-style')) return;
    var style = document.createElement('style');
    style.id = 'elite-gallery-cache-hotfix-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function setImportant(el, prop, value) {
    if (el) el.style.setProperty(prop, value, 'important');
  }

  function fixGallery() {
    // Catalog product galleries use their own responsive panel layout.
    if (document.querySelector('.elite-product-main[data-catalog-mobile-layout]')) return;
    injectCss();
    var gallery = document.querySelector('.elite-product-gallery');
    var productMain = document.querySelector('.elite-product-main');
    var productGrid = document.querySelector('.elite-product-main__grid');
    var mediaColumn = document.querySelector('.elite-product-main__media-column');
    var details = document.querySelector('.elite-product-details');
    var detailsCore = document.querySelector('.elite-product-details__core');
    var main = document.querySelector('.elite-product-gallery__main');
    var mainButton = document.querySelector('.elite-product-gallery__main-button');
    var mainImage = document.querySelector('.elite-product-gallery__main-image');
    var thumbs = document.querySelector('.elite-product-gallery__thumbs');
    var modal = document.querySelector('.elite-product-gallery-modal');
    var isModalOpen = document.body.classList.contains('elite-gallery-modal-open') || (modal && !modal.hidden);
    var isMobileGallery = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
    var isDesktopProductGrid = window.matchMedia && window.matchMedia('(min-width: 1121px)').matches;
    var mediaInset = isMobileGallery ? 18 : 32;

    setImportant(productMain, 'z-index', isModalOpen ? '4000' : 'auto');
    setImportant(gallery, 'position', 'relative');
    setImportant(gallery, 'inset', 'auto');
    setImportant(gallery, 'height', 'auto');
    setImportant(gallery, 'grid-template-rows', 'auto auto auto');
    setImportant(gallery, 'z-index', isModalOpen ? '4000' : 'auto');
    setImportant(modal, 'z-index', '4010');
    setImportant(main, 'min-height', 'clamp(340px, 38vw, 520px)');
    setImportant(main, 'height', 'auto');
    setImportant(main, 'aspect-ratio', '4 / 3');
    setImportant(mainButton, 'position', 'relative');
    setImportant(mainButton, 'height', '100%');
    setImportant(mainButton, 'padding', '0');
    setImportant(mainButton, 'touch-action', 'pan-y');
    setImportant(mainImage, 'display', 'block');
    setImportant(mainImage, 'position', 'absolute');
    setImportant(mainImage, 'left', mediaInset + 'px');
    setImportant(mainImage, 'top', mediaInset + 'px');
    setImportant(mainImage, 'right', 'auto');
    setImportant(mainImage, 'bottom', 'auto');
    setImportant(mainImage, 'width', 'calc(100% - ' + (mediaInset * 2) + 'px)');
    setImportant(mainImage, 'height', 'calc(100% - ' + (mediaInset * 2) + 'px)');
    setImportant(mainImage, 'max-width', 'none');
    setImportant(mainImage, 'max-height', 'none');
    setImportant(mainImage, 'object-fit', 'contain');
    setImportant(mainImage, 'object-position', 'center center');
    setImportant(thumbs, 'position', 'relative');
    setImportant(thumbs, 'inset', 'auto');
    setImportant(thumbs, 'height', 'auto');
    setImportant(thumbs, 'margin-top', '0');

    if (isMobileGallery) {
      setImportant(thumbs, 'box-sizing', 'border-box');
      setImportant(thumbs, 'display', 'flex');
      setImportant(thumbs, 'gap', '8px');
      setImportant(thumbs, 'overflow-x', 'auto');
      setImportant(thumbs, 'overflow-y', 'visible');
      setImportant(thumbs, 'width', 'calc(100% + 8px)');
      setImportant(thumbs, 'padding', '16px 16px 9px 8px');
      setImportant(thumbs, 'margin-left', '-8px');
      setImportant(thumbs, 'margin-top', '-16px');
      setImportant(thumbs, 'scroll-padding-inline', '8px 16px');
    }

    if (isDesktopProductGrid) {
      setImportant(productGrid, 'align-items', 'stretch');
      setImportant(mediaColumn, 'align-content', 'stretch');
      setImportant(mediaColumn, 'align-items', 'stretch');
      setImportant(mediaColumn, 'display', 'grid');
      setImportant(mediaColumn, 'grid-template-rows', 'minmax(0, 1fr)');
      setImportant(mediaColumn, 'align-self', 'stretch');
      setImportant(mediaColumn, 'height', 'auto');
      setImportant(mediaColumn, 'min-height', '100%');

      setImportant(gallery, 'align-self', 'stretch');
      setImportant(gallery, 'grid-template-rows', 'minmax(0, 1fr) auto auto');
      setImportant(gallery, 'gap', '14px');
      setImportant(gallery, 'height', '100%');
      setImportant(gallery, 'min-height', '100%');

      setImportant(main, 'height', '100%');
      setImportant(mainButton, 'height', '100%');

      setImportant(details, 'display', 'grid');
      setImportant(details, 'align-self', 'stretch');
      setImportant(details, 'height', 'auto');
      setImportant(details, 'min-height', '100%');
      setImportant(detailsCore, 'align-self', 'stretch');
      setImportant(detailsCore, 'height', '100%');
      setImportant(detailsCore, 'min-height', '100%');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixGallery);
  } else {
    fixGallery();
  }

  window.addEventListener('load', fixGallery);
  setTimeout(fixGallery, 250);
  setTimeout(fixGallery, 1000);
})();
